import React from "react";
import { useBranding } from "@/lib/branding";
import Layout from "@/components/Layout";
import { Sparkles, MessageCircle, Clock, ShieldCheck } from "lucide-react";

/**
 * `/ai-help` — dedicated AI Companion page. Embeds the DyNamic Tax AI
 * companion (hosted on muse.ai) via a friendly iframe so clients can
 * ask tax questions any time without waiting for a human.
 */
export default function AiHelp() {
  const { branding } = useBranding();
  const brandName = branding?.brand_name || "DyNamic Tax";
  return (
    <Layout>
      <div className="max-w-4xl mx-auto p-6 lg:p-12 space-y-8" data-testid="ai-help-page">
        <div>
          <div className="label-caps mb-2 flex items-center gap-2">
            <Sparkles size={14} /> {brandName} AI · 24/7
          </div>
          <h1 className="font-serif text-4xl lg:text-6xl leading-none mb-3">Ask our AI Companion.</h1>
          <p className="text-muted-foreground max-w-xl">
            Got a tax question? Not sure which documents you need? Wondering about your refund? Ask away — our AI knows your services, your pricing, and current tax rules. Available any hour of any day.
          </p>
        </div>

        {/* AI Companion iframe */}
        <iframe
          src="https://muse.ai/s/ai-companion-xqxo6wxwxajixnpxi"
          title={`${brandName} AI Companion`}
          width="100%"
          height="700"
          style={{ border: 0, borderRadius: 16 }}
          loading="lazy"
          allow="clipboard-write"
          data-testid="ai-help-iframe"
        />

        {/* Reassurance strip */}
        <div className="grid sm:grid-cols-3 gap-4 pt-2">
          <div className="p-4 rounded-md border border-border">
            <Clock size={16} className="text-primary mb-2" />
            <div className="text-sm font-medium mb-1">24/7 answers</div>
            <div className="text-xs text-muted-foreground">Ask at 2am, ask on Sunday — the companion never sleeps.</div>
          </div>
          <div className="p-4 rounded-md border border-border">
            <MessageCircle size={16} className="text-primary mb-2" />
            <div className="text-sm font-medium mb-1">Real preparer follow-up</div>
            <div className="text-xs text-muted-foreground">If the AI can't answer, drop your name and a preparer takes it from there.</div>
          </div>
          <div className="p-4 rounded-md border border-border">
            <ShieldCheck size={16} className="text-primary mb-2" />
            <div className="text-sm font-medium mb-1">Private by design</div>
            <div className="text-xs text-muted-foreground">Don't share your SSN, bank, or ID numbers here — those go in your intake form.</div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
